import { TemplateFieldsDisplayFn } from '../../../../models/template.model';
import { PACIFIC_SUMMARY_COMMON } from './pacific-summary-common';

export const displayFnMap: TemplateFieldsDisplayFn = {
  ...PACIFIC_SUMMARY_COMMON,
};
